import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { actvReducer } from "./actv/actvReducer";
import { showStores } from "./showStores";
import { showRunners } from "./showRunners";
import { showHelps } from "./showHelp";
import { showZones } from "./showZone";
import { showUserAddresses } from "./showUserAddresses";

export const rootReducer = combineReducers({
  actvReducer: actvReducer,
  showStores: showStores,
  showRunners: showRunners,
  showHelps: showHelps,
  showZones: showZones,
  showUserAddresses: showUserAddresses,
});
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
export type RootState = ReturnType<typeof rootReducer>;
